import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import { useMemo } from 'react';
import QuickFiltersValueDisplay from './QuickFiltersValueDisplay';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersDisplay = props => {
  const {
    filterFamily,
    condition,
    onValueDelete
  } = props;
  const {
    getFieldLabelString
  } = useTranslationHelpers(filterFamily);
  const labelString = useMemo(() => getFieldLabelString(condition.field), [condition.field, getFieldLabelString]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("strong", {
      children: [labelString, ":"]
    }), /*#__PURE__*/_jsx(QuickFiltersValueDisplay, {
      filterFamily: filterFamily,
      condition: condition,
      onValueDelete: onValueDelete
    })]
  });
};
export default QuickFiltersDisplay;